import {
	CheckCircleIcon,
	ExclamationCircleIcon,
	XMarkIcon,
} from '@heroicons/react/16/solid';
import clsx from 'clsx';

export type ToastProps = {
	id?: number;
	title: string;
	text: string;
	type: 'info' | 'success' | 'error';
};

export function Toast({ title, text, type }: ToastProps) {
	const cn = clsx(
		'flex gap-4 rounded border-l-2 border-s-4 bg-white p-4 text-base/6 text-gray-700 shadow-md',
		{
			'border-l-green-500 bg-green-50 shadow-green-500/10': type === 'success',
			'border-red-500 bg-red-50 shadow-red-500/10': type === 'error',
			'border-l-blue-500': type === 'info',
		},
	);

	const iconClass = clsx(
		{
			'border-green-100 bg-green-200 text-green-600': type === 'success',
			'border-red-100 bg-red-200 text-red-800': type === 'error',
			'border-blue-100 bg-blue-200 text-blue-800': type === 'info',
		},
		'inline-flex size-8 items-center justify-center rounded-full border-4 p-1',
	);

	return (
		<div className={cn}>
			<div className="shrink-0">
				{type === 'info' && <ExclamationCircleIcon className={iconClass} />}
				{type === 'success' && <CheckCircleIcon className={iconClass} />}
				{type === 'error' && <XMarkIcon className={iconClass} />}
			</div>
			<div>
				<h3 className="font-semibold">{title}</h3>
				<p>{text}</p>
			</div>
		</div>
	);
}
